export enum WeatherCode {
    SUNNY, CLOUDY, WINDY, RAINY, SNOWY
}